<template>
	<app>
		<crumb-bar></crumb-bar>
		<module>
			<c-title>我要申请开工令</c-title>
			<c-form ref="form">
				<c-form>
					<c-form-item type="hidden" name="kgl_id"></c-form-item>
					<c-form-item v-model="currentProjectId" type="select" label="项目名称" name="project_id" :options="projectList" required :disabled="!!id"></c-form-item>
					<c-form-item type="input" label="业主单位" name="yzdw_name" required disabled></c-form-item>
					<c-form-item type="input" label="监理单位" name="jldw_name" required disabled></c-form-item>
					<c-form-item type="input" label="企业名称" name="zbqy_name" required disabled></c-form-item>
					<c-form-item type="input" label="施工建设地址" name="xm_address" required disabled></c-form-item>
					<c-form-item type="input" label="备注说明" name="remark"></c-form-item>
				</c-form>
			
				<c-title>项目关联保函</c-title>
				<project-insurance :project-id="currentProjectId" :data="insuranceList"></project-insurance>
				
				<c-title>其他资料上传</c-title>
				<c-detail>
					<c-detail-item label="营业执照" required full>
						<c-upload-file v-model="datumDetail.yyzz_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="法人身份证头像面" required full>
						<c-upload-file v-model="datumDetail.frsfztx_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="法人身份证国徽面" required full>
						<c-upload-file v-model="datumDetail.frsfzgh_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="资质证书" required full>
						<c-upload-file v-model="datumDetail.zzzs_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="施工方案" required full>
						<c-upload-file v-model="datumDetail.sgfa_path" type="word,excel,pdf,zip,image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="其它文件" full>
						<c-upload-file v-model="datumDetail.other_path" type="word,excel,pdf,zip,image"></c-upload-file>
					</c-detail-item>
					<c-button slot="button" size="m" width="300" @click="submit">提交申请</c-button>
				</c-detail>
			</c-form>
		</module>
	</app>
</template>

<script>
	import projectInsurance from '@/pages/insurance/project_insurance.vue'
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		components: {
			projectInsurance
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				projectList: [],
				currentProjectId: '',
				insuranceList: [],
				datumDetail: {}
			}
		},
		
		computed: {
			...mapState(['userInfo']),
			...mapGetters(['insuranceState'])
		},
		
		watch: {
			currentProjectId(val) {
				if (val) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: val
						},
						success: data => {
							this.$refs.form.set({
								yzdw_name: data.project_info.yzdw_name,
								jldw_name: data.project_info.jldw_name,
								zbqy_name: data.project_info.zbqy_name,
								xm_address: data.project_info.xm_address
							});
							this.insuranceList = data.bx_list;
						}
					});
				}
			}
		},
		
		mounted() {
			this.request({
				url: '/project/select_list',
				data: {
					type: 3
				},
				success: data => {
					this.projectList = Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					});
				}
			});
			
			if (this.id) {
				this.request({
					url: '/project/kgl/detail',
					data: {
						kgl_id: this.id
					},
					success: data => {
						this.$refs.form.set({
							kgl_id: this.id
						});
						this.$refs.form.set(data.kglInfo);
						this.datumDetail = {
							yyzz_path: data.kglInfo.yyzz_path,
							frsfztx_path: data.kglInfo.frsfztx_path,
							frsfzgh_path: data.kglInfo.frsfzgh_path,
							zzzs_path: data.kglInfo.zzzs_path,
							sgfa_path: data.kglInfo.sgfa_path,
							other_path: data.kglInfo.other_path
						};
					}
				});
			} else {
				this.datumDetail = {
					yyzz_path: this.userInfo.yyzz_path,
					frsfztx_path: this.userInfo.frsfztx_path,
					frsfzgh_path: this.userInfo.frsfzgh_path,
					zzzs_path: this.userInfo.zzzs_path,
					sgfa_path: '',
					other_path: ''
				};
			}
		},
		
		methods: {
			submit() {
				this.$refs.form.submit({
					url: this.id ? '/project/kgl/updateBase' : '/project/kgl/add',
					beforeValidate: data => {
						return Object.assign(data, this.datumDetail);
					},
					rule: {
						project_id: '请选择项目',
						yyzz_path: '请上传营业执照',
						frsfztx_path: '请上传法人身份证头像面',
						frsfzgh_path: '请上传法人身份证国徽面',
						zzzs_path: '请上传资质证书',
						sgfa_path: '请上传施工方案'
					},
					success: (data, res) => {
						this.$message({
							text: '提交成功'
						});
						this.navigateTo('/transact/proceed');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
